import { Component } from '@angular/core';
import { HelpContentComponent } from '../../../../UI-Lib/Help-Tooltip';

export interface AssessorAddressTooltipComponentParams {
    address: Core.AddressModel;
}

@Component({
    selector: 'assessor-address-tooltip',
    template: `
        @if (!params.address) {
          <em>No Address Selected</em>
        }
        <address-view-edit [address]="params.address" [isEditMode]="false"></address-view-edit>
        `,
    standalone: false
})
export class AssessorAddressTooltipComponent implements HelpContentComponent<AssessorAddressTooltipComponentParams> {
    params: AssessorAddressTooltipComponentParams;

    helpInit(params: AssessorAddressTooltipComponentParams): void {
        this.params = params;
    }
}
